import useLanguageNavigate from '@hooks/useLanguageNavigate';
import AccountCircleIcon from '@mui/icons-material/AccountCircle';
import LogoutOutlinedIcon from '@mui/icons-material/LogoutOutlined';
import SettingsIcon from '@mui/icons-material/Settings';
import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { MenuItem } from '../types';

interface UseMenuItemsProps {
	userRole?: string;
	onLogout: () => void;
	isLoggingOut?: boolean;
	onClose: () => void;
}

export const useMenuItems = ({
	userRole,
	onLogout,
	isLoggingOut = false,
	onClose,
}: UseMenuItemsProps) => {
	const { t } = useTranslation();
	const { navigateWithLanguage } = useLanguageNavigate();
	const isFarmer = userRole?.toLowerCase() === 'farmer';

	const specialistMenuItems = useMemo<MenuItem[]>(
		() => [
			{
				icon: <AccountCircleIcon className="mr-[10px]" />,
				text: t('myProfile'),
				link: '/specialist/profile',
				onClick: () => {
					onClose();
					navigateWithLanguage('/specialist/profile');
				},
			},
			{
				icon: <SettingsIcon className="mr-[10px]" />,
				text: t('accountSettings'),
				link: '/specialist/settings',
				onClick: () => {
					navigateWithLanguage('/specialist/settings');
					onClose();
				},
			},
			{
				icon: <LogoutOutlinedIcon className="mr-[10px]" />,
				text: t('logout'),
				onClick: onLogout,
			},
		],
		[t, navigateWithLanguage, onClose, onLogout]
	);

	const farmerMenuItems = useMemo<MenuItem[]>(
		() => [
			{
				icon: <AccountCircleIcon className="mr-[10px]" />,
				text: t('myProfile'),
				link: '/farmer/profile',
				onClick: () => {
					onClose();
					navigateWithLanguage('/farmer/profile');
				},
			},
			{
				icon: <SettingsIcon className="mr-[10px]" />,
				text: t('accountSettings'),
				link: '/farmer/settings',
				onClick: () => {
					navigateWithLanguage('/farmer/settings');
					onClose();
				},
			},
			{
				icon: <LogoutOutlinedIcon className="mr-[10px]" />,
				text: t('logout'),
				disabled: isLoggingOut,
				onClick: onLogout,
			},
		],
		[t, navigateWithLanguage, onClose, onLogout, isLoggingOut]
	);

	return {
		menuItems: isFarmer ? farmerMenuItems : specialistMenuItems,
	};
};
